<template>
    <div id="fixedHeader" class="fixed-header">
        <statusBar></statusBar>
        <div v-if="isShowDownAppNav && false" class="downApp">
            <div class="icon-close" @click="onCloseDownAppNav">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
            <div class="tips">{{ domainKey }} {{ $t("footer.ApplicableTo") }} {{ sysPlatform == 'Windows' ? 'Windows' :
                            (sysPlatform == 'ios' ? 'IOS' : 'Android') }}</div>
            <!-- <div class="tips">
                <span>{{ $t("home.DownloadTips") }}</span>
                <span class="money">{{ CurrencyType }}100</span>
            </div> -->
            <div class="btn" @click="onShowDownAppPopup">
                <i class="iconfont icon-shouji"></i>
                <span>{{ $t("home.Download") }}</span>
            </div>
        </div>
        <div class="pages-header">
            <div class="area_left">
                <img class="icon_toggle" src="@/assets/header/icon_toggle.png" alt="" @click="toggleSideBar">
                <!-- <i class="icon_toggle iconfont icon-caidanshouqi" :class="{'sidebarOpened': sidebar.opened}" @click="toggleSideBar"></i> -->
                <div v-if="device !== 'mobile'" class="down_box" @click="onShowDownAppPopup">
                    <div class="down_img">
                        <img src="@/assets/header/icon_window.png" alt="" />
                    </div>
                    <div class="down_info">
                        <div>{{ $t("downApp.ApplicableWindows") }}</div>
                        <div>{{ $t("downApp.ApplicableWindowsTips") }}</div>
                    </div>
                </div>
            </div>
            <div v-if="device !== 'mobile'" class="search_btn" @click.stop="toSearch" >
                <i class="iconfont icon-sousuo"></i>
                <div class="txt"> {{ $t("home.SearchGames") }}</div>
            </div>
            <div class="icon_logo" :class="{'mobile_logo': device == 'mobile'}">
                <img v-if="device == 'mobile'" class="logo" :src="logoUrl2" @click.stop="onPageRefresh" />
                <img v-else class="logo" :src="logoUrl" @click.stop="onPageRefresh" />
            </div>
            <div class="user_action">
                <div></div>
                <div>
                    <div v-if="isLogin && device === 'mobile'" class="user_info">
                        <div class="iconfont icon-shuaxin" :class="{'turning':isRefreshingMoney}" @click.stop="getUserInfo"></div>
                        <div class="user_money">
                            {{ CurrencyType }}{{ allBalance }}
                        </div>
                        <div class="deposit" @click.stop="toDeposit">+</div>
                    </div>
                    <div v-if="isLogin && device !== 'mobile'" class="user_info" @click.stop="toMy">
                        <img class="u_avatar" src="@/assets/person/avatar.png" />
                        <div class="u-info">
                            <div>Hi, {{ userPhone }}</div>
                            <div>ID:{{ userInfo.id }}</div>
                        </div>
                        <img class="u-arrow" src="@/assets/header/icon_arrow.png" />
                    </div>
                    <div v-if="!isLogin" class="user_login">
                        <div class="sign_up" @click="toLogin(1)">
                            <div class="register-reward">
                                <img src="@/assets/common/liwu.png" alt="" class="empty_img">
                                <div class="register-reward-text">+{{ eventRegisterReward }}</div>
                            </div>
                            {{ $t("login.SignUp") }}
                        </div>
                        <div class="login" @click="toLogin(2)">{{ $t("login.SignIn") }}</div>
                    </div>
                    <div v-if="isLogin" class="Notification" @click.stop="toNotification">
                        <i class="iconfont icon-xiangling"></i>
                        <div v-if="noticeNumber" class="matterNumber">{{ noticeNumber }}</div>
                    </div>
                </div>
            </div>
        </div>
        <logoutPopup ref="logoutPopup"></logoutPopup>
        <!-- <BonusTransferPopup ref="BonusTransferPopup" @confirm="isLogin && getUserInfo()"></BonusTransferPopup> -->
    </div>
</template>

<script>
import { domainKey } from '@/common/http'
import statusBar from '@/components/statusBar'
import logoutPopup from '@/components/logoutPopup'
import { mapState } from 'vuex'
import { getUserInfo } from '@/api/user'
import { isPWA, getPlatform } from '@/utils'
import { Toast } from 'vant'
let savedPwaPrompt888 = null
// import BonusTransferPopup from '@/components/BonusTransferPopup'
export default {
    name: 'Header',
    components: { statusBar, logoutPopup },
    data() {
        return {
            sysPlatform: getPlatform(),
            domainKey,
            pathAct: '',
            isRefreshingMoney: false
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device,
            sidebar: state => state.app.sidebar
        }),
        eventRegisterReward() {
            return this.$store.state.user.eventRegisterReward
        },
        isLogin() {
            return !!this.$store.getters.token
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        isShowDownAppNav() {
            const isShowDownAppNav = Number(this.$store.state.system.isShowDownAppNav)
            // let downType = this.$store.state.vuex_sysConfig && this.$store.state.vuex_sysConfig.downType || 'apk'
            return isShowDownAppNav === 1 && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android' && getPlatform() !== 'ios'
        },
        noticeNumber() {
            return this.$store.getters.noticeNumber
        }
    },
    created() {
        this.pathAct = this.$route.name
        // if (this.isLogin) getUserInfo()
    },
    mounted() {
        try {
            this.$nextTick(() => {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    // 把事件存起来
                    savedPwaPrompt888 = e
                })
            })
        } catch {
            console.log('error-pwa-不支持？不显示？')
        }
    },
    methods: {
        getUserInfo() {
            this.isRefreshingMoney = true
            getUserInfo().finally(() => {
                this.isRefreshingMoney = false
            })
        },
        onMenuItem(act) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            this.onNavTo({ url: act, type: 'post' })
        },
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar')
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toMy() {
            this.$store.dispatch('user/setIsShowMyPopup', true)
        },
        // onShowDownAppPopup() {
        //     this.$store.dispatch('user/setIsShowDownAppPopup', true)
        // },
        onCloseDownAppNav() {
            this.$store.dispatch('system/setIsShowDownAppNav', 2)
        },
        onShowDownAppPopup() {
            if (this.sysPlatform === 'WebAndroidGame') {
                this.$store.dispatch('user/setIsShowDownAppPopup', true)
            }
            if (this.sysPlatform === 'Windows') {
                if ('serviceWorker' in navigator) {
                    try {
                        savedPwaPrompt888.prompt()
                        savedPwaPrompt888.userChoice.then(choiceResult => {
                            if (choiceResult.outcome === 'accepted') {
                                // this.isShowTipsPopup = true
                                // uni.reLaunch({
                                // 	url: '/pages/index/index'
                                // })
                            } else {
                                console.log('用户拒绝安装PWA--可打印')
                            }
                        })
                    } catch (e) {
                        console.log(e, 'error-pwa-不支持？不显示？')
                        // pwaIconShow.value = false
                    }
                } else {
                    console.log('当前设备不支持')
                }
            }
            // if (this.sysPlatform === 'ios') {
            //     this.$refs.pwaIosPopup.open()
            // }
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toNotification() {
            if (this.$route.path.indexOf('/notification') !== -1) {
                return
            }
            const params = { type: 1 }
            this.onNavTo({ url: '/notification', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.fixed-header {
    width: 100%;
    position: relative;
    z-index: 98;
    // box-shadow: 0 4px 20px #0006;
    background: linear-gradient(180deg, #5a2406 0%, #311306 55%, #160b05 100%);

    @keyframes move {
        0%, 65% {
            transform: rotate(0);
        }
        70% {
            transform: rotate(6deg);
        }
        75% {
            transform: rotate(-6deg);
        }
        80% {
            transform: rotate(6deg);
        }
        85% {
            transform: rotate(-6deg);
        }
        90% {
            transform: rotate(6deg);
        }
        95% {
            transform: rotate(-6deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    .downApp {
        background: linear-gradient(90deg, #f90, #ec0039);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .2rem;
        box-sizing: border-box;
        height: .9rem;
        position: relative;

        &>div.icon-close {
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, .3);
            border-bottom-right-radius: 100%;
            width: .53rem;
            height: .45rem;
            padding-right: .08rem;
            padding-bottom: .1rem;
            box-sizing: border-box;

            &>i {
                font-size: .2rem;
                font-weight: bold;
                color: rgba(255, 255, 255, .8);
            }
        }

        &>div.tips {
            padding-left: .28rem;
            color: #fff;
            font-size: .28rem;

            .money {
                color: #f3df00;
                font-size: .3rem;
                font-weight: 700;
            }
        }

        &>div.btn {
            background: #fff;
            color: #ec0048;
            font-size: .18rem;
            line-height: .5rem;
            padding: .048rem .16rem;
            padding-right: .2rem;
            border-radius: .2rem;
            display: flex;
            align-items: center;

            &>i {
                margin-right: .08rem;
            }
        }
    }

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        height: 1rem;
        box-sizing: border-box;
        position: relative;

        .area_left{
            position: absolute;
            left: .34rem;
            display: flex;
            align-items: center;
            z-index: 8;

            .icon_toggle{
                color: #ffffff;
                font-size: .48rem;
                margin-right: .16rem;
                transition: all .3s;
                width: .52rem;
                height: .52rem;
                vertical-align: middle;
                cursor: pointer;

                &.sidebarOpened{
                    transform: rotate(180deg);
                }
            }

            .down_box {
                background: linear-gradient(180deg, rgba(106, 38, 5, .96) 0%, rgba(45, 19, 8, .98) 100%);
                padding: 4px 6px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                cursor: pointer;
                width: 212px;
                text-align: left;

                .down_img{
                    width: .6rem;
                    height: .6rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    background: rgba(43, 22, 10, .92);
                }

                img {
                    width: .4rem;
                    height: .4rem;
                    vertical-align: middle;
                }

                .down_info {
                    font-size: 13px;
                    color: #fff;
                    flex: 1;
                    margin-left: 0.12rem;
                    font-weight: bold;
                    line-height: 18px;

                    &> div:last-child {
                        line-height: 15px;
                        font-size: 12px;
                        color: #ffc078;
                    }
                }
            }
        }

        .search_btn{
            width: 150px;
            height: 44px;
            border: .02rem solid rgba(255, 138, 0, .36);
            border-radius: 10px;
            display: flex;
            align-items: center;
            color: #ffd2a3;
            cursor: pointer;
            margin-left: 20px;
            position: absolute;
            left: 320px;
            cursor: pointer;
            z-index: 7;

            .txt {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                // height: 44px;
                // line-height: 42px;
                font-size: 15px;
            }

            .iconfont {
                font-weight: bold;
                height: 44px;
                width: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &>div.icon_logo {
            margin-left: 1rem;
            .logo {
                height: .68rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
                background: transparent;
                padding: 0;
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            // margin-right: .2rem;

            &>div:last-child {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .user_info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-width: 3.15rem;
                height: .76rem;
                padding: .06rem .08rem;
                border-radius: .16rem;
                background: #18110c;
                overflow: hidden;
                box-sizing: border-box;
                border: 1px solid #4a2d18;

                .icon-shuaxin {
                    color: #F8F9F9;
                    font-size: .3rem;
                    // width: .45rem;
                    margin-right: .08rem;
                    text-align: center;

                    &.turning {
                        animation: rotateAni 0.2s linear infinite;
                    }

                    @keyframes rotateAni {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(-360deg);
                        }
                    }
                }

                .user_account,
                .user_money {
                    color: #FFFFFF;
                    padding: 0 .08rem;
                    border-radius: .2rem;
                    margin-top: 0;
                    font-size: .26rem;
                    font-weight: 700;
                    letter-spacing: .01rem;
                    white-space: nowrap;
                }

                .user_account {
                    color: #ffc58b;
                }

                .deposit {
                    height: .52rem;
                    border-radius: .13rem;
                    background:linear-gradient(145deg, #ff8a00 0%, #e65100 100%);
                    color: #000000;
                    line-height: .52rem;
                    font-size: .5rem;
                    margin-left: .08rem;
                    cursor: pointer;
                    width: .52rem;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;

                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background-image: linear-gradient(90deg, transparent, rgba(255, 255, 255, .5), transparent);
                        background-repeat: no-repeat;
                        animation: bgmove-1badf8a4 linear 2.5s infinite;
                    }

                    @keyframes bgmove-1badf8a4 {
                        0% {
                            background-position: -200px 0
                        }

                        to {
                            background-position: 400px 0
                        }
                    }
                }
            }

            .Notification {
                width: .72rem;
                height: .72rem;
                background: linear-gradient(180deg, rgba(106, 38, 5, .96) 0%, rgba(45, 19, 8, .98) 100%);
                border-radius: 23px;
                margin: 0 10px 0 15px;
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #18110c;
                border: 1px solid #4a2d18;
                border-radius: .14rem;

                &:hover {
                    background: #2b1e15;
                }

                &>i {
                    font-size: .36rem;
                    color: #FFFFFF;
                }

                .matterNumber{
                    position: absolute;
                    height: .3rem;
                    width: .3rem;
                    border-radius: 50px;
                    background: #ff0000;
                    color: #fff;
                    font-size: .2rem;
                    top:-.02rem;
                    right: -.02rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .user_login {
                font-size: .22rem;
                height: .7rem;
                line-height: .6rem;
                display: flex;
                align-items: center;
                white-space: nowrap;
                margin-right: .2rem;

                .register-reward {
                    display: none;
                    position: absolute;
                    top: -13px;
                    left: -10px;
                    align-items: center;
                    .empty_img {
                        width: .5rem;
                        height: .5rem;
                        animation: move 3s linear infinite;
                    }
                    .register-reward-text {
                        position: absolute;
                        top: 6px;
                        left: 27px;
                        box-sizing: border-box;
                        min-width: .32rem;
                        padding: 0 .08rem;
                        font-weight: 700;
                        height: .26rem;
                        color: #ffffff;
                        text-align: center;
                        background: #ff7000;
                        border-radius: .13rem .13rem .13rem 0;
                        font-size: .18rem;
                        font-weight: 400;
                        line-height: .26rem;
                        letter-spacing: normal;
                        overflow: visible;
                    }
                    .register-reward-text:after {
                        display: inline-block;
                        position: absolute;
                        top: auto;
                        bottom: -.04rem;
                        z-index: 20;
                        left: 0;
                        width: 0;
                        height: 0;
                        border-left: .079rem solid #ff7000;
                        border-top: .066rem solid transparent;
                        border-bottom: .066rem solid transparent;
                        font-size: 0;
                        content: "";
                    }
                }

                .login {
                    color: #ffffff;
                    cursor: pointer;
                    text-align: center;
                    padding: 0 .18rem;
                    border-radius: .1rem;
                    margin-right: .02rem;
                    background: none;
                    border: 1px solid #6d5140;
                    width: 1.76rem;
                    height: .6rem;
                }

                .sign_up {
                    color: #000000;
                    cursor: pointer;
                    text-align: center;
                    border-radius: .15rem;
                    padding: 0 .22rem;
                    background: linear-gradient(145deg, #ff8a00 0%, #e65100 100%);
                    margin-right: .12rem;
                    font-weight: 400;
                    width: 1.76rem;
                    height: .6rem;
                    position: relative;
                }
            }
        }
    }
    .pages-header:after {
        top: auto;
        bottom: 0px;
        width: 3rem;
        height: 1.5px;
        background: linear-gradient(90deg, rgba(255, 138, 0, .72), transparent);
        content: "";
        position: absolute;
        left: 0px;
        z-index: 20;
    }
}

</style>
